import { List } from 'immutable';
import { getIsReportStacked, getReportStackingType } from 'reporting-data/report/reportGetters';
import { ALLOWED_STACK_VALUES } from 'reporting-visualizations/constants/stacking';
import { MarkEncoding } from 'reporting-visualizations/visualizations/xy/xyRecords';
export const applyStacked = (visualization, report) => {
  const reportStacking = getIsReportStacked(report);
  const reportStackingType = getReportStackingType(report) || '';
  const isValidStackingType = ALLOWED_STACK_VALUES.includes(reportStackingType);
  if (!reportStacking) {
    return visualization;
  }
  return visualization.update('layers', (layers = List()) => layers.map(layer => layer.get('dataset') === 'compare' ? layer : layer.update('mark', (mark = MarkEncoding({})) => mark.set('stacking', isValidStackingType ? reportStackingType : true).set('stack', 'DEFAULT_STACK'))));
};